import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIsDesktop } from '@cian/valuation-utils-component';

import { DesktopView, MobileView } from '../../components/Tabs';
import { selectDealType } from '../../selectors/page';
import { EDealType } from '../../types/dealType';
import { setDealType, updateUrl } from '../../actions/page';
import { useIsReportStatusDefault } from '../../utils/report';
import { trackDealTypeTabsClick } from './tracking';
import { useGetTabs } from '../../utils/tabs';
import { getEstimationChartData } from '../../actions/estimationChart';
import { TRefWrapper } from '../Scrolling';
import { checkExistRateOurEstimation } from '../../actions/rateOurEstimation';
import { TThunkDispatch } from '../../types/redux';

interface ITabsContainerProps {
  refWrapper: TRefWrapper;
}

export const TabsContainer: React.FC<ITabsContainerProps> = ({ refWrapper }) => {
  const dispatch = useDispatch<TThunkDispatch>();
  const isDesktop = useIsDesktop();
  const dealType = useSelector(selectDealType);
  const isReportStatusDefault = useIsReportStatusDefault();
  const tabs = useGetTabs();
  const ref = React.useRef(null);

  const onChangeDealType = React.useCallback(
    (value: EDealType) => {
      dispatch(setDealType(value));
      dispatch(getEstimationChartData());
      dispatch(updateUrl());
      dispatch(checkExistRateOurEstimation());
      trackDealTypeTabsClick(value);
    },
    [dispatch],
  );

  /**
   * Отображаем табы только при редактировании отчета
   */
  if (!isReportStatusDefault) {
    return null;
  }

  const Component = isDesktop ? DesktopView : MobileView;

  return refWrapper(<Component ref={ref} tabs={tabs} dealType={dealType} onChange={onChangeDealType} />);
};

TabsContainer.displayName = 'TabsContainer';
